import React from "react";
import { Plus, Trash2 } from "lucide-react";

export default function SingleChoiceBlockEditor({ block, onChange }) {
    const config = block.config || {};
    const options = Array.isArray(config.options) ? config.options : [];

    const updateConfig = (patch) => {
        onChange({
            config: {
                ...config,
                ...patch,
            },
        });
    };

    const updateOption = (optionId, patch) => {
        const nextOptions = options.map((opt) =>
            opt.id === optionId ? { ...opt, ...patch } : opt
        );
        updateConfig({ options: nextOptions });
    };

    const addOption = () => {
        // validator requires 2..6 options
        if (options.length >= 6) return;

        const nextOptions = [
            ...options,
            { id: crypto.randomUUID(), text: "" },
        ];

        updateConfig({ options: nextOptions });
    };

    const deleteOption = (optionId) => {
        // validator requires 2..6 options
        if (options.length <= 2) return;

        const nextOptions = options.filter((opt) => opt.id !== optionId);

        const nextCorrectOptionId =
            config.correctOptionId === optionId ? null : config.correctOptionId;

        updateConfig({
            options: nextOptions,
            correctOptionId: nextCorrectOptionId,
        });
    };

    const canAdd = options.length < 6;
    const canDelete = options.length > 2;

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium mb-1">متن سوال</label>
                <textarea
                    className="w-full p-3 border rounded-lg bg-gray-50"
                    value={config.prompt || ""}
                    onChange={(e) => updateConfig({ prompt: e.target.value })}
                    placeholder="سوال را وارد کنید..."
                />
                <div className="mt-1 text-xs text-gray-500">
                    تعداد گزینه‌ها باید بین ۲ تا ۶ باشد.
                </div>
            </div>

            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <label className="block text-sm font-medium">گزینه‌ها</label>

                    <button
                        type="button"
                        onClick={addOption}
                        disabled={!canAdd}
                        className="inline-flex items-center gap-1 px-3 py-2 rounded-lg bg-blue-600 text-white text-sm disabled:opacity-40 disabled:cursor-not-allowed"
                        title={!canAdd ? "حداکثر ۶ گزینه مجاز است" : undefined}
                    >
                        <Plus size={14} />
                        افزودن گزینه
                    </button>
                </div>

                {options.map((opt, index) => (
                    <div
                        key={opt.id}
                        className="flex items-center gap-2 p-2 border rounded-lg bg-white"
                    >
                        <input
                            type="radio"
                            name={`single-choice-${block.id}`}
                            checked={config.correctOptionId === opt.id}
                            onChange={() => updateConfig({ correctOptionId: opt.id })}
                        />

                        <input
                            className="flex-1 p-2 border rounded-lg bg-gray-50"
                            value={opt.text || ""}
                            onChange={(e) => updateOption(opt.id, { text: e.target.value })}
                            placeholder={`گزینه ${index + 1}`}
                        />

                        <button
                            type="button"
                            onClick={() => deleteOption(opt.id)}
                            disabled={!canDelete}
                            className="p-2 rounded hover:bg-red-50 text-red-600 disabled:opacity-40 disabled:hover:bg-transparent disabled:cursor-not-allowed"
                            title={!canDelete ? "حداقل ۲ گزینه باید باقی بماند" : undefined}
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
